<ng-container *transloco="let t; prefix: 'tasks.taskFilter'">
  <div mat-dialog-title class="dialog-header">
    <span class="dialog-title title-large">{{ t('title') }}</span>
    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'tasks.ui.chiudi' | transloco"
      class="close-button"
      (click)="onClose()">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <mat-dialog-content class="content" [formGroup]="filterForm">
    <section class="filter-section">
      <span class="title-medium">{{ t('type') }}</span>
      <mat-chip-listbox multiple hideSingleSelectionIndicator="true">
        @for (tipo of tipiTask; track tipo) {
          <mat-chip-option
            (selectionChange)="onTipoTaskSelect($event, tipo)"
            [selected]="checkTipoTaskSelected(tipo)">
            {{ typeKeys[tipo] ? t(typeKeys[tipo]) : tipo }}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    </section>

    <section class="filter-section">
      <span class="title-medium">{{ t('dateRange') }}</span>
      <div class="date-container">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('from') }}</mat-label>
          <input
            matInput
            [placeholder]="'tasks.ui.datePlaceholder' | transloco"
            [matDatepicker]="pickerInizio"
            [formControl]="filterForm.controls['dataInizio']"
            [max]="filterForm.controls['dataFine'].value">
          <mat-datepicker-toggle matIconSuffix [for]="pickerInizio"></mat-datepicker-toggle>
          <mat-datepicker #pickerInizio></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ t('to') }}</mat-label>
          <input
            matInput
            [placeholder]="'tasks.ui.datePlaceholder' | transloco"
            [matDatepicker]="pickerFine"
            [formControl]="filterForm.controls['dataFine']"
            [min]="filterForm.controls['dataInizio'].value">
          <mat-datepicker-toggle matIconSuffix [for]="pickerFine"></mat-datepicker-toggle>
          <mat-datepicker #pickerFine></mat-datepicker>
        </mat-form-field>
      </div>
    </section>

    <section class="filter-section">
      <span class="title-medium">{{ t('priority') }}</span>
      <div class="priority-options" role="group" [attr.aria-label]="t('priority')">
        @for (priority of priorities; track priority) {
          <button
            type="button"
            class="priority-option"
            [class.priority-option-selected]="checkPrioritySelected(priority)"
            [attr.aria-pressed]="checkPrioritySelected(priority)"
            (click)="togglePriority(priority)">
            <ui-priority-status [priority]="priority"></ui-priority-status>
          </button>
        }
      </div>
    </section>
  </mat-dialog-content>

  <mat-dialog-actions class="buttons-container">
    <button matButton type="button" (click)="onCancelFilter()">{{ t('clear') }}</button>
    <button matButton="filled" type="button" (click)="onConfirmFilter()">{{ t('apply') }}</button>
  </mat-dialog-actions>
</ng-container>
